import { useQuery } from 'react-query';
import { SapOdataAPI } from 'api';
import { TQuery } from 'api/api.types';
import { SOPDocument } from './sap-odata.types';

export const useSOPDocumentList = (config: TQuery<SOPDocument[]> = {}) => {
  return useQuery(['sap-odata-sop-documents'], () => SapOdataAPI.getSOPDocumentList(), {
    staleTime: 1000 * 60 * 5,
    ...config
  });
};
